<div class="note-type-settings-container">
    <div class="settings-header">
        <h2>NOTE SETTINGS</h2>
        <p class="hint"> Customise the headings that you would like MedicAI to use when extracting information for
            specific note types. This is customisable to suit your practice needs. Create the type of notes that you
            would require and assign heading for these note types. MedicAI will screen through your recordings and
            generate notes according the relevant headings.
        </p>
    </div>
    <mat-accordion multi="false">
        <mat-expansion-panel [expanded]="false" tutorialExpansionTarget="AI_NOTE">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    DEFAULT NOTE TYPES
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let noteType of noteTypes" class="note-type-section">
                <ng-container *ngIf="!noteType.canDelete">
                    <div class="action-heading">
                        <h3 class="m-r-10"><span *ngIf="noteType.forAi && !noteType.forCura">(AI)</span><span *ngIf="noteType.forCura">(Cura)</span> {{ noteType.label }}
                            {{noteType.isProcedure ? '(Procedure Note)' : ''}}{{noteType.isBilling ? ' (Billing Note)' : ''}}</h3>
                        <button mat-button (click)="openAddNoteTypeDialog(null, noteType)"
                            matTooltip="Edit this note type" color="primary"
                            class="m-b-10"><mat-icon>edit</mat-icon><span *ngIf="noteType.forAi">Edit</span></button>
                        <button mat-icon-button *ngIf="noteType.canDelete" (click)="deleteNoteType(noteType.id)"
                            matTooltip="Delete this note type" color="warn"><mat-icon>delete</mat-icon></button>
                    </div>

                    <pre [innerHtml]="noteType.templateText" class="preserve-line-breaks note-template-text"
                        *ngIf="!noteType.forAi && !noteType.forCura"></pre>

                    <mat-form-field class="full-width" appearance="outline" *ngIf="noteType.forAi || noteType.forCura">
                        <mat-label>{{ noteType.label }} Headings</mat-label>
                        <mat-chip-grid #chipGrid aria-label="Enter headings">
                            <ng-container *ngFor="let heading of noteType.headings">
                                <mat-chip-row (removed)="removeHeading(noteType, heading)" appTouchEdit [editable]="true"
                                    (edited)="editHeading(noteType, heading, $event)">
                                    {{heading.text}}
                                    <button matChipTrailingIcon [matMenuTriggerFor]="subheadingsMenu"
                                        [matMenuTriggerData]="{ heading: heading, noteType:noteType, autoSave: true }"
                                        matTooltip="Add subheadings">
                                        <mat-icon>expand_more</mat-icon>
                                    </button>
                                    <button matChipRemove matTooltip="Remove heading">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip-row>

                                <ng-container *ngFor="let subheading of heading.subheadings">
                                    <mat-chip-row class="subheading-chip"
                                        (removed)="removeSubheading(noteType, heading, subheading)" appTouchEdit [editable]="true"
                                        (edited)="editSubheading(noteType, heading, subheading, $event)">
                                        {{subheading.text}}
                                        <button matChipRemove matTooltip="Remove subheading">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                </ng-container>

                            </ng-container>

                            <input placeholder="New Heading..." [matChipInputFor]="chipGrid"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                                (matChipInputTokenEnd)="addHeading(noteType, $event)" />
                        </mat-chip-grid>
                        <mat-hint>Double click or tap and hold headings to edit their text or click edit above to change the order
                            of headings</mat-hint>
                    </mat-form-field>
                </ng-container>
            </div>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="false" tutorialExpansionTarget="CUSTOM_NOTE">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    CUSTOM NOTE TYPES
                    <mat-icon class="expansion-header-icon" (click)="openAddNoteTypeDialog($event, null)"
                        matTooltip="Add a new note type" color="primary"
                        tutorialHighlightTarget="CUSTOM_NOTE">add</mat-icon>
                    <mat-icon *ngIf="isSupportUser" class="expansion-header-icon m-l-10"
                        (click)="openImportNoteTypesDialog($event)" matTooltip="Import note types from JSON"
                        color="primary">upload</mat-icon>
                    <mat-icon *ngIf="noteTypeTemplates.length > 0" class="expansion-header-icon m-l-10"
                        (click)="openImportTemplatesDialog($event)" matTooltip="Import note types from templates"
                        color="primary">cloud_download</mat-icon>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div *ngFor="let noteType of noteTypes" class="note-type-section">
                <ng-container *ngIf="noteType.canDelete">
                    <div class="action-heading">
                        <h3 class="m-r-10"><span *ngIf="noteType.forAi && !noteType.forCura">(AI)</span><span *ngIf="noteType.forCura">(Cura)</span> {{ noteType.label }}
                            {{noteType.isProcedure ? '(Procedure Note)' : ''}}{{noteType.isBilling ? ' (Billing Note)' : ''}}</h3>
                        <button mat-button (click)="openAddNoteTypeDialog(null, noteType)"
                            matTooltip="Edit this note type" color="primary"
                            class="m-b-10"><mat-icon>edit</mat-icon><span *ngIf="noteType.forAi">Edit</span></button>
                        <button mat-icon-button *ngIf="noteType.canDelete" (click)="deleteNoteType(noteType.id)"
                            matTooltip="Delete this note type" color="warn"><mat-icon>delete</mat-icon></button>
                    </div>

                    <pre [innerHtml]="noteType.templateText" class="preserve-line-breaks note-template-text"
                        *ngIf="!noteType.forAi && !noteType.forCura"></pre>

                    <mat-form-field class="full-width" appearance="outline" *ngIf="noteType.forAi || noteType.forCura">
                        <mat-label>{{ noteType.label }} Headings</mat-label>
                        <mat-chip-grid #chipGrid aria-label="Enter headings">
                            <ng-container *ngFor="let heading of noteType.headings">
                                <mat-chip-row (removed)="removeHeading(noteType, heading)" appTouchEdit [editable]="true"
                                    (edited)="editHeading(noteType, heading, $event)">
                                    {{heading.text}}
                                    <button matChipTrailingIcon [matMenuTriggerFor]="subheadingsMenu"
                                        [matMenuTriggerData]="{ heading: heading, noteType:noteType, autoSave: true }"
                                        matTooltip="Add subheadings">
                                        <mat-icon>expand_more</mat-icon>
                                    </button>
                                    <button matChipRemove matTooltip="Remove heading">
                                        <mat-icon>cancel</mat-icon>
                                    </button>
                                </mat-chip-row>

                                <ng-container *ngFor="let subheading of heading.subheadings">
                                    <mat-chip-row class="subheading-chip"
                                        (removed)="removeSubheading(noteType, heading, subheading)" appTouchEdit [editable]="true"
                                        (edited)="editSubheading(noteType, heading, subheading, $event)">
                                        {{subheading.text}}
                                        <button matChipRemove matTooltip="Remove subheading">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                </ng-container>
                            </ng-container>
                            <input placeholder="New Heading..." [matChipInputFor]="chipGrid"
                                [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                                (matChipInputTokenEnd)="addHeading(noteType, $event)" />
                        </mat-chip-grid>
                        <mat-hint>Double click or tap and hold headings to edit their text or click edit above to change the order
                            of headings</mat-hint>
                    </mat-form-field>
                </ng-container>


            </div>
        </mat-expansion-panel>

    </mat-accordion>
    <div class="mobile-spacer"></div>
</div>

<ng-template #addNoteTypeDialog>
    <h1 mat-dialog-title>Note Type Details</h1>
    <div mat-dialog-content>
        <div class="p-t-20">

            <div class="m-b-10">
                <mat-slide-toggle [(ngModel)]="editingNoteType.forAi" color="primary"
                    [disabled]="!editingNoteType.canDelete || editingNoteType.isBilling"
                    (change)="onForAiToggle($event)">AI Note Type</mat-slide-toggle>
            </div>
            <p class="hint">
                Note: AI Note types are specifically designed for extracting information from audio files to generate
                notes. If you disable this option, you can create a custom note type for manually creating notes,
                allowing greater flexibility in designing your template.
            </p>

            <div class="m-b-10">
                <mat-slide-toggle [(ngModel)]="editingNoteType.forCura" color="primary"
                    [disabled]="!editingNoteType.canDelete || editingNoteType.isBilling"
                    (change)="onForCuraToggle($event)">For Cura</mat-slide-toggle>
            </div>
            <p class="hint">
                Note: When enabled, this note type will be available for selection in the Cura AI Assistant. 
                When selected, Cura will generate content using the headings, subheadings, and user instructions defined for this note type.
                Note types marked as "For Cura" will be excluded from other note type selections.
            </p>

            <div class="m-b-10">
                <mat-slide-toggle [(ngModel)]="editingNoteType.isBilling" color="primary"
                    [disabled]="!editingNoteType.canDelete || editingNoteType.forAi || editingNoteType.forCura"
                    (change)="onIsBillingToggle($event)">Billing Note</mat-slide-toggle>
            </div>
            <p class="hint">
                Note: Billing notes are specifically designed for billing purposes and cannot be used as procedure notes, AI notes, or Cura notes. 
                When enabled, this note type will be marked as a billing note and will appear in the billing notes filter on the patient timeline.
            </p>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Note Type Name</mat-label>
                <input matInput [(ngModel)]="editingNoteType.label" placeholder="Note Type Name" type="text" required
                    [disabled]="!editingNoteType.canDelete">
            </mat-form-field>

            <div class="m-b-10" *ngIf="!editingNoteType.forCura && !editingNoteType.isBilling">
                <mat-slide-toggle [(ngModel)]="editingNoteType.isProcedure" color="primary"
                    [disabled]="!editingNoteType.canDelete || editingNoteType.isBilling"
                    (change)="onIsProcedureToggle($event)">Procedure Note</mat-slide-toggle>
            </div>

            <mat-form-field appearance="outline" class="full-width" *ngIf="!editingNoteType.forAi && !editingNoteType.forCura">
                <mat-label>Template Text</mat-label>
                <textarea matInput [(ngModel)]="editingNoteType.templateText" rows="4"></textarea>
            </mat-form-field>

            <mat-form-field class="full-width" appearance="outline" *ngIf="editingNoteType.forAi || editingNoteType.forCura">
                <mat-label>{{ editingNoteType.label }} Headings</mat-label>
                <mat-chip-grid #chipGrid aria-label="Enter headings">
                    <div cdkDropList cdkDropListOrientation="vertical" [cdkDropListData]="editingNoteType.headings"
                        (cdkDropListDropped)="drop($event)">
                        <div *ngFor="let heading of editingNoteType.headings; let i = index" cdkDrag>
                            <mat-chip-row (removed)="removeHeading(editingNoteType, heading, false)" appTouchEdit [editable]="true"
                                (edited)="editHeading(editingNoteType, heading, $event, false)">
                                {{heading.text}}
                                <button matChipTrailingIcon [matMenuTriggerFor]="subheadingsMenu"
                                    [matMenuTriggerData]="{ heading: heading, noteType: editingNoteType, autoSave: false }"
                                    matTooltip="Add subheadings">
                                    <mat-icon>expand_more</mat-icon>
                                </button>
                                <button matChipRemove matTooltip="Remove heading">
                                    <mat-icon>cancel</mat-icon>
                                </button>
                            </mat-chip-row>

                            <div cdkDropList cdkDropListOrientation="vertical" [cdkDropListData]="heading.subheadings"
                                (cdkDropListDropped)="dropSubheading($event, heading)">
                                <div *ngFor="let subheading of heading.subheadings" cdkDrag>
                                    <mat-chip-row class="subheading-chip"
                                        (removed)="removeSubheading(editingNoteType, heading, subheading, false)"
                                        appTouchEdit [editable]="true"
                                        (edited)="editSubheading(editingNoteType, heading, subheading, $event, false)">
                                        {{ subheading.text }}
                                        <button matChipRemove matTooltip="Remove subheading">
                                            <mat-icon>cancel</mat-icon>
                                        </button>
                                    </mat-chip-row>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input placeholder="New Heading..." [matChipInputFor]="chipGrid"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                        (matChipInputTokenEnd)="addHeading(editingNoteType, $event, false)" />
                </mat-chip-grid>
                <mat-hint>Double click or tap and hold headings to edit their text or drag and drop to edit their order</mat-hint>
            </mat-form-field><br><br>

            <ng-container *ngIf="editingNoteType?.forAi || editingNoteType?.forCura">
                <mat-form-field appearance="outline" class="full-width m-t-10">
                    <mat-label>{{ editingNoteType?.forCura ? 'Cura' : 'AI' }} Instructions</mat-label>
                    <textarea matInput rows="6" placeholder="Enter Your {{ editingNoteType?.forCura ? 'Cura' : 'AI' }} Instructions"
                        [(ngModel)]="editingNoteType.userPrompt">
                  </textarea>
                    <mat-hint>This can be used to fine-tune the output of your {{ editingNoteType?.forCura ? 'Cura' : 'AI' }} generated notes</mat-hint>
                </mat-form-field>

            </ng-container>

        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="saveNoteType(editingNoteType)">Save</button>
    </div>

</ng-template>

<ng-template #importNoteTypesDialog>
    <h1 mat-dialog-title>Import Note Types from JSON</h1>
    <div mat-dialog-content class="p-t-10">
        <mat-form-field class="full-width" appearance="outline">
            <mat-label>Note Types JSON</mat-label>
            <textarea matInput rows="10" placeholder="Paste your Note Type JSON object or array here"
                [(ngModel)]="importNoteTypesJson" (change)="validateJson()"></textarea>
        </mat-form-field>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-raised-button color="primary" (click)="importNoteTypes()">Import</button>
    </div>
</ng-template>

<ng-template #importTemplatesDialog>
    <h1 mat-dialog-title>Import Note Types from Templates</h1>
    <div mat-dialog-content class="p-t-10">
        <p class="m-b-20">Select one or more note type templates to import into your group:</p>
        <div *ngIf="noteTypeTemplates.length === 0" class="m-t-10 m-b-10">
            <p>No templates available for your specialty.</p>
        </div>
        <div *ngIf="noteTypeTemplates.length > 0" class="template-list">
            <mat-selection-list #templateList (selectionChange)="onTemplateSelectionChange($event)">
                <mat-list-option *ngFor="let template of noteTypeTemplates" [value]="template.id" checkboxPosition="before">
                    {{ template.label }}
                </mat-list-option>
            </mat-selection-list>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" (click)="importSelectedTemplates()" [disabled]="selectedTemplateIds.length === 0">
            Import Selected ({{ selectedTemplateIds.length }})
        </button>
    </div>
</ng-template>

<!-- Template for Subheadings Context Menu -->
<mat-menu #subheadingsMenu="matMenu" class="p-10 subheadings-menu">
    <ng-template matMenuContent let-parent="heading" let-nt="noteType" let-save="autoSave">
        <div (click)="$event.stopPropagation()">
            <mat-form-field class="full-width" appearance="outline">
                <mat-label>{{ parent.text }} Subheadings</mat-label>
                <mat-chip-grid #subheadingChipGrid aria-label="Enter subheadings">
                    <mat-chip-row *ngFor="let subheading of parent.subheadings"
                        (removed)="removeSubheading(nt, parent, subheading, save)" appTouchEdit [editable]="true"
                        (edited)="editSubheading(nt, parent, subheading, $event, save)">
                        {{ subheading.text }}
                        <button matChipRemove matTooltip="Remove subheading">
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip-row>
                    <input placeholder="New Subheading..." [matChipInputFor]="subheadingChipGrid"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                        (matChipInputTokenEnd)="addSubheading(nt, parent, $event, save)" />
                </mat-chip-grid>
                <mat-hint>Double click or tap and hold subheadings to edit their text</mat-hint>
            </mat-form-field>
        </div>
    </ng-template>

</mat-menu>